import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kys-additional-info',
  templateUrl: './kys-additional-info.component.html',
  styleUrls: ['./kys-additional-info.component.scss']
})
export class KysAdditionalInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  openModal(){
    const buttonModal = document.getElementById("openModalButton")
    console.log('buttonModal', buttonModal)
    buttonModal.click()
  }

}
